let hostName = window.location.host;
hostName = hostName.split('.');

let apiUrl;

      {hostName.length === 2 ?
         apiUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://192.168.100.55:7003/api/WebApi/" :  `https://api.${hostName[0]}.${hostName[1]}/api/WebApi/` 
        :
         apiUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://192.168.100.55:7003/api/WebApi/" :  `https://api.${hostName[1]}.${hostName[2]}/api/WebApi/` 
      }  
//  "http://45.89.239.188:8011/api/WebApi/" 
export {apiUrl}



